<template>
  <div class="semi_verified_page" :style="{ textAlign: $store.state.isMirroring ? 'right' : 'left' }">
    <Tabbar :title="$t('basicLevel.identityVerification')" />
    <div v-if="fromSidebar" class="verify_tabs">
      <div class="verify_tab active">{{ $t('account.basicTab') }}</div>
      <div class="verify_tab" @click="goAdvanced">{{ $t('account.advancedTab') }}</div>
    </div>
    <div class="page_content">
      <div class="info_card">
        <div class="fill_hint">{{ $t('basicLevel.fillInfoHint') }}</div>
        <div class="info_list">
          <div class="info_row">
            <div class="info_label">{{ $t('common.firstName') }}</div>
            <div class="info_value">{{ userInfo.firstName }}</div>
          </div>
          <div class="info_row">
            <div class="info_label">{{ $t('common.lastName') }}</div>
            <div class="info_value">{{ userInfo.lastName }}</div>
          </div>
          <div class="info_row">
            <div class="info_label">{{ $t('common.gender') }}</div>
            <div class="info_value">{{ genderText }}</div>
          </div>
          <div class="info_row">
            <div class="info_label">{{ $t('common.birthday') }}</div>
            <div class="info_value">{{ formatBirthday }}</div>
          </div>
          <div class="info_row">
            <div class="info_label">{{ $t('common.email') }}</div>
            <div class="info_value">{{ userInfo.email }}</div>
          </div>
          <div class="info_row address">
            <div class="info_label">{{ $t('common.address') }}</div>
            <div class="info_value">{{ userInfo.address }}</div>
          </div>
        </div>
      </div>
      <CommonBtn
        v-if="showConfirm"
        class="confirm_btn"
        :text="$t('common.confirm')"
        :onClick="onConfirm"
      />
    </div>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar'
import CommonBtn from '@/components/CommonBtn'
import moment from 'moment'
import { postReportLog } from '../utils/log'

export default {
  name: 'SemiVerified',
  components: {
    Tabbar,
    CommonBtn
  },
  data() {
    return {
      canEditBasic: false
    }
  },
  created() {
    postReportLog({
      log_id: '440',
      extra: {
        page: 'semi_verified'
      }
    })
    this.getBasicUpdateStatus()
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || {}
    },
    userLevel() {
      return this.userInfo.level || 0
    },
    fromSidebar() {
      return this.$route.query.from === 'sidebar'
    },
    showConfirm() {
      return this.userLevel < 1 || this.canEditBasic
    },
    genderText() {
      return this.userInfo.gender === 0 ? this.$t('common.male') : this.$t('common.female')
    },
    formatBirthday() {
      if (!this.userInfo.birthday) {
        return ''
      }
      return moment(this.userInfo.birthday).format('DD-MM-YYYY')
    }
  },
  methods: {
    getBasicUpdateStatus() {
      this.$http.get(window.serverPath + '/api/user/getBasicUpdateStatus').then((res) => {
        if (res.data && res.data.code === '200') {
          this.canEditBasic = res.data.data === 1
        }
      })
    },
    onConfirm() {
      if (this.userLevel < 1) {
        this.goAdvanced()
        return
      }
      this.$router.push({ name: 'EditBasicLevel', query: { ...this.$route.query } })
    },
    goAdvanced() {
      this.$router.replace({ name: 'FullyVerified', query: { ...this.$route.query } })
    }
  }
}
</script>

<style scoped>
.semi_verified_page {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-y: auto;
  scrollbar-width: none;
}

.semi_verified_page::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.verify_tabs {
  display: flex;
  width: 100%;
  padding: 0 0.16rem;
  box-sizing: border-box;
  border-bottom: 0.01rem solid #efefef;
}

.verify_tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.08rem 0;
  color: #828282;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  border-bottom: 0.02rem solid transparent;
  margin-bottom: -0.01rem;
  box-sizing: border-box;
}

.verify_tab.active {
  color: #3fbb70;
  border-bottom-color: #3fbb70;
}

.page_content {
  display: flex;
  flex-direction: column;
  padding: 0 0.16rem;
}

.info_card {
  display: flex;
  flex-direction: column;
  gap: 0.04rem;
  padding: 0.12rem 0;
  border-radius: 0.18rem;
  background: #fff;
}

.fill_hint {
  width: 100%;
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.2rem;
}

.info_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.12rem;
  height: 0.6rem;
  border-bottom: 0.01rem solid #efefef;
  box-sizing: border-box;
}

.info_row.address {
  height: auto;
  align-items: flex-start;
  gap: 0.2rem;
  padding: 0.2rem 0;
  border-bottom: none;
}

.info_label {
  flex-shrink: 0;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
}

.info_value {
  flex: 1;
  min-width: 0;
  color: #828282;
  text-align: right;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  word-break: break-word;
}

.confirm_btn {
  width: 100% !important;
  font-size: 0.16rem !important;
  background: linear-gradient(90deg, #43d77d 0%, #3fbb70 100%) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/SemiVerified.vue